import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.colors.white,
    width: '100%',
    alignSelf: 'center',
    maxWidth: 768,
    borderRadius: theme.borderRadii.xl,
    overflow: 'hidden',
  },
  headerNeutral: {
    fontWeight: 'bold',
    fontSize: theme.fontSizes.xl,
    padding: theme.spacings.md,
    flex: 1,
  },
  headerDanger: {
    fontWeight: 'bold',
    fontSize: theme.fontSizes.xl,
    padding: theme.spacings.md,
    color: theme.colors.white,
    flex: 1,
  },
  scrollViewBounded: {
    maxHeight: 384,
  },
  contentPadding: {
    padding: theme.spacings.md,
  },
  contentText: {
    fontSize: theme.fontSizes.xl,
  },
  buttonRow: {
    padding: theme.spacings.md,
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  titleRowNeutral: {
    backgroundColor: theme.colors.grey,
  },
  titleRowDanger: {
    backgroundColor: theme.colors.red,
  },
  closeXButton: {
    padding: theme.spacings.md,
  },
});
